import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';
import H7 from 'UIComponents/elements/headings/H7';
import HR from 'UIComponents/elements/HR';
import UISection from 'UIComponents/section/UISection';
import Small from 'UIComponents/elements/Small';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import Recommendations from './Recommendations';
import Reasons from './Reasons';
import Insight from './Insight';
import InsightFeedback from '../Feedback';
import Loading from '../Shared/Loading';
import Error from '../Shared/Error';
import useFetchEmailInsights from '../../hooks/useFetchEmailInsights';
import InsightsEmptyState from '../AllInsights/InsightsEmptyState';
import { useInsightContext } from '../InsightContextProviderBase';
import { FRAMEWORK_INSIGHT_CONTEXT_TO_COMPARISON_TYPE } from '../../constant';
import { isDeliverabilityMetricInsight } from '../../types';
import { isNonEmptyArray } from '../../types/arrays';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function InsightPanelSubSection({
  heading,
  endSlot,
  children,
  className
}) {
  return /*#__PURE__*/_jsxs(UISection, {
    className: className,
    children: [heading && /*#__PURE__*/_jsxs("div", {
      className: "insight-panel-heading align-center justify-between m-bottom-1",
      children: [/*#__PURE__*/_jsx(H7, {
        className: "m-bottom-0",
        children: heading
      }), endSlot]
    }), /*#__PURE__*/_jsx(_Fragment, {
      children: children
    })]
  });
}
function EmailInsightsTab({
  nonCrmObject
}) {
  var _nonCrmObject$primary;
  const {
    context
  } = useInsightContext();
  const {
    id: emailContentId,
    businessUnitId,
    emailType
  } = (_nonCrmObject$primary = nonCrmObject === null || nonCrmObject === void 0 ? void 0 : nonCrmObject.primaryEmail) !== null && _nonCrmObject$primary !== void 0 ? _nonCrmObject$primary : {};
  const {
    emailInsight,
    loading,
    error,
    refetch
  } = useFetchEmailInsights({
    emailContentId,
    businessUnitId,
    comparisonType: FRAMEWORK_INSIGHT_CONTEXT_TO_COMPARISON_TYPE[context]
  });
  if (!nonCrmObject || loading) {
    return /*#__PURE__*/_jsx(Loading, {});
  }
  if (error) {
    return /*#__PURE__*/_jsx(Error, {
      errors: error
    });
  }
  if (!(emailInsight !== null && emailInsight !== void 0 && emailInsight.insights)) {
    return /*#__PURE__*/_jsx(InsightsEmptyState, {
      panelName: "detail"
    });
  }
  return emailInsight.insights.map(insight => {
    var _emailInsight$spotlig, _emailInsight$reasons, _emailInsight$recomme;
    if (!isDeliverabilityMetricInsight(insight)) return null;
    const spotlights = (_emailInsight$spotlig = emailInsight.spotlights) === null || _emailInsight$spotlig === void 0 ? void 0 : _emailInsight$spotlig.filter(spotlight => spotlight.insightType === insight.insightType);
    const reasons = (_emailInsight$reasons = emailInsight.reasons) === null || _emailInsight$reasons === void 0 ? void 0 : _emailInsight$reasons.filter(({
      insightId
    }) => insightId === insight.id);
    const recommendations = (_emailInsight$recomme = emailInsight.recommendations) === null || _emailInsight$recomme === void 0 ? void 0 : _emailInsight$recomme.filter(({
      insightId
    }) => insightId === insight.id);
    const [spotlight] = spotlights;
    const {
      createdAt,
      sentiment
    } = spotlight;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(View, {
        marginBlockStart: "500",
        marginInline: "500",
        marginBlockEnd: "200",
        as: "div",
        children: [/*#__PURE__*/_jsx(InsightPanelSubSection, {
          className: "m-bottom-2",
          heading: /*#__PURE__*/_jsx(UIHelpIcon, {
            tooltipProps: {
              use: 'longform',
              maxWidth: 300
            },
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "messaging-insights.insights.insight.tooltip"
            }),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "messaging-insights.insights.insight.title"
            })
          }),
          endSlot: /*#__PURE__*/_jsx(Small, {
            children: /*#__PURE__*/_jsx(FormattedReactMessage, {
              message: "messaging-insights.insights.generatedOn",
              options: {
                date: /*#__PURE__*/_jsx(FormattedDateTime, {
                  value: createdAt,
                  format: "ll"
                }),
                time: /*#__PURE__*/_jsx(FormattedDateTime, {
                  value: createdAt,
                  format: "LT"
                })
              }
            })
          }),
          children: /*#__PURE__*/_jsx(Insight, {
            context: context,
            spotlight: spotlight,
            insight: insight
          })
        }), /*#__PURE__*/_jsx(InsightPanelSubSection, {
          heading: /*#__PURE__*/_jsx(UIHelpIcon, {
            tooltipProps: {
              use: 'longform',
              maxWidth: 300
            },
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "messaging-insights.insights.reasons.tooltip"
            }),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "messaging-insights.insights.reasons.title"
            })
          }),
          children: /*#__PURE__*/_jsx(Reasons, {
            reasons: reasons,
            sentiment: sentiment
          })
        }), isNonEmptyArray(recommendations) && /*#__PURE__*/_jsx(InsightPanelSubSection, {
          heading: /*#__PURE__*/_jsx(UIHelpIcon, {
            tooltipProps: {
              use: 'longform',
              maxWidth: 300
            },
            title: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "messaging-insights.insights.recommendations.tooltip"
            }),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "messaging-insights.insights.recommendations.title"
            })
          }),
          children: /*#__PURE__*/_jsx(Recommendations, {
            recommendations: recommendations
          })
        }), /*#__PURE__*/_jsx(InsightFeedback, {
          insight: insight,
          sentiment: sentiment,
          refetchInsights: refetch,
          emailType: emailType
        })]
      }, insight.id), /*#__PURE__*/_jsx(HR, {
        distance: "flush"
      })]
    });
  });
}
export default EmailInsightsTab;